import { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import OrderBasketScreen from '../pages/OrderBasketScreen';
import PageNotFound from '../pages/PageNotFound';
import RestaurantDetailsScreen from '../pages/RestaurantDetailsScreen';
import { SCREENS } from '../services/exports/Constants';
import useScreenFallback from '../hooks/navigation/useScreenFallback';
import { RoutesInterface } from '../services/exports/Interfaces';
import TermsAndConditions from '../pages/legal/TermsAndConditions';
import PrivacyPolicy from '../pages/legal/PrivacyPolicy';
import CookiePolicy from '../pages/legal/CookiePolicy';
import GlobalAppUtility from '../services/utilities/GlobalAppUtility';
import ScrollToTop from '../components-library/navigation/ScrollToTop';
import GlobalModalsStack from '../modals/GlobalModalsStack';
import UploadGoogleReviewScreen from '../pages/UploadGoogleReviewScreen';
import RewardDetailsScreen from '../pages/RewardDetailsScreen';
import useAppState from '../hooks/global/useAppState';
import useAppMethods from '../hooks/utility/useAppMethods';
import Impressum from '../pages/legal/Impressum';
import CheckoutScreen from '../pages/CheckoutScreen';
import OrderDetailsScreen from '../pages/OrderDetailsScreen';
import OrderDraftPreloader from '../providers/OrderDraftPreloader';
import NhasUserTokenAuthenticator from '../providers/auth/NhasUserTokenAuthenticator';
import WindowResource from '../services/resources/WindowResource';
import AppliedOfferToast from '../features/offers/components/AppliedOfferToast';
import useScreenType from '../hooks/utility/useScreenType';
import useWatchOffers from '../features/offers/hooks/useWatchOffers';

function Router() {
  const screenFallback = useScreenFallback();
  const { isDesktop } = useScreenType();

  useWatchOffers();

  const companyRoutes: RoutesInterface[] = [
    {
      path: `${SCREENS.BASKET}`,
      element: <OrderBasketScreen />,
    },
    {
      path: `${SCREENS.ORDER_DETAILS}/:uuid`,
      element: <OrderDetailsScreen />,
    },
    {
      path: SCREENS.CHECKOUT,
      element: <CheckoutScreen />,
    },
    {
      path: SCREENS.TERMS_AND_CONDITIONS,
      element: <TermsAndConditions />,
    },
    {
      path: SCREENS.PRIVACY_POLICY,
      element: <PrivacyPolicy />,
    },
    {
      path: SCREENS.COOKIE_POLICY,
      element: <CookiePolicy />,
    },
    {
      path: SCREENS.IMPRESSUM,
      element: <Impressum />,
    },
    {
      path: SCREENS.UPLOAD_GOOGLE_REVIEW_SCREEN,
      element: <UploadGoogleReviewScreen />,
      // protectedType: 'Auth',
    },
    {
      path: SCREENS.REWARD_DETAILS_SCREEN,
      element: <RewardDetailsScreen />,
      protectedType: 'Auth',
    },
    {
      path: '*',
      element: <PageNotFound />,
    },
  ];

  const ROUTES: RoutesInterface[] = [
    {
      path: SCREENS.NOT_FOUND_SCREEN,
      element: <PageNotFound />,
    },
    ...companyRoutes,
    {
      path: ':slug',
      children: [
        {
          path: '',
          element: <RestaurantDetailsScreen />,
        },
        ...companyRoutes,
      ],
    },
    {
      path: SCREENS.HOME_SCREEN,
      element: <RestaurantDetailsScreen />,
    },
    {
      path: '*',
      element: <PageNotFound />,
    },
  ];

  const GlobalAppMethods = useAppMethods();
  const GlobalAppState = useAppState();

  GlobalAppUtility.setGlobalAppMethodsContext(GlobalAppMethods);

  useEffect(() => {
    GlobalAppUtility.setGlobalAppStateContext(GlobalAppState);
  }, [GlobalAppState]);

  return (
    <>
      <BrowserRouter basename={WindowResource.basePath}>
        <Routes>
          {ROUTES.map((route: RoutesInterface) => (
            <Route path={route.path} {...(route?.element ? { element: screenFallback(route) } : {})} key={route.path}>
              {route.children?.map((item) => (
                <Route path={item.path} element={screenFallback(item)} key={item.path} />
              ))}
            </Route>
          ))}
        </Routes>
        <ScrollToTop />
        <GlobalModalsStack />
        <OrderDraftPreloader />
        <NhasUserTokenAuthenticator />
        {isDesktop && <AppliedOfferToast />}
      </BrowserRouter>
    </>
  );
}

export default Router;
